<template>
  <div class="dashboard-container">
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
      </vs-row>
    </template>
    <vx-card title="대시보드"  >
      <div class="vx-col w-full lg:w-5/5">
        <div class="text-right mb-base lg:w-5/5" style="margin-right:2%">
            <vs-button @click="printDashboard()" size="small">프린트</vs-button>
        </div>
      </div>
      <div class="table-container">
      <div id="printArea" class="vx-row w-full page full-screen" >
          <!-- <div class="vx-row w-full">
            <table id="dashboardTable" border="1">
              <thead>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="4">오더 요청</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" rowspan="2" colspan="2">침치료({{ acupunctureList.length }})</th>
                </tr>
                <tr>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">김정권 원장님({{ mergedJeongList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">금충수 원장님({{ mergedKeumList.length + unSelectedList.length }})</th>
                </tr>
              </thead>
              <tbody>
                
                <tr :key="index" v-for=" index in orderMaxCount">
                  <td>{{ mergedJeongList[index-1] ? mergedJeongList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ mergedJeongList[index-1] ? mergedJeongList[index-1].MEDICAL_DETAIL_NM : ''}}</td>
                  <td>{{ mergedKeumList[index-1] ? (mergedKeumList[index-1].WEST_MEDICAL_UID == '09001' ?  mergedKeumList[index-1].PATIENT_USERNAME + '(임시)' : mergedKeumList[index-1].PATIENT_USERNAME) : ''}}</td>
                  <td>{{ mergedKeumList[index-1] ? mergedKeumList[index-1].MEDICAL_DETAIL_NM : ''}}</td>
                  <td>{{ acupunctureList[index-1] ? acupunctureList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ acupunctureList[index-1] ? acupunctureList[index-1].TIME_STRING : ''}}</td>
                </tr>

                
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="2">신입({{ inInitPatientList.length }})</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="2">재입({{ inPatientList.length }})</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="2">퇴원({{ outPatientList.length }})</th>
                </tr>
                <tr :key="index" v-for="index in patientRowCount">
                  <td>{{ inInitPatientList[index-1] ? inInitPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td></td>
                  <td>{{ inPatientList[index-1] ? inPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td></td>
                  <td>{{ outPatientList[index-1] ? outPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table id="dashboardTable3">
                <thead>
                  <tr>
                    <th style="text-align: center;font-size: large;font-weight: bold;" >신입({{ inInitPatientList.length }})</th>
                    <th style="text-align: center;font-size: large;font-weight: bold;" >재입({{ inPatientList.length }})</th>
                    <th style="text-align: center;font-size: large;font-weight: bold;" >퇴원({{ outPatientList.length }})</th>
                  </tr>
                </thead> 
                <tbody>
                  <tr :key="index" v-for="index in patientRowCount">
                    <td >{{inInitPatientList[index-1] ? inInitPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                    <td >{{inPatientList[index-1] ? inPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                    <td >{{outPatientList[index-1] ? outPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                  </tr>
                </tbody>
              </table>
          </div> -->
        <div id="printArea" class="vx-row w-full page" style="display: flex; justify-content: flex-start; flex-wrap: nowrap;">
        <!-- 왼쪽: 오더 요청 + 침치료 -->
          <div style="width: fit-content; margin:0 !important;">
            <table id="dashboardTable" border="1" style="width: fit-content;">
              <thead>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="4">오더 요청</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" rowspan="2" colspan="2">침치료({{ acupunctureList.length }})</th>
                </tr>
                <tr>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">김정권 원장님({{ mergedJeongList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">금충수 원장님({{ mergedKeumList.length + unSelectedList.length }})</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="index in orderMaxCount">
                  <td>{{ mergedJeongList[index-1] ? mergedJeongList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ mergedJeongList[index-1] ? mergedJeongList[index-1].MEDICAL_DETAIL_NM : ''}}</td>
                  <td>{{ mergedKeumList[index-1] ? (mergedKeumList[index-1].WEST_MEDICAL_UID == '09001' ? mergedKeumList[index-1].PATIENT_USERNAME + '(임시)' : mergedKeumList[index-1].PATIENT_USERNAME) : ''}}</td>
                  <td>{{ mergedKeumList[index-1] ? mergedKeumList[index-1].MEDICAL_DETAIL_NM : ''}}</td>
                  <td>{{ acupunctureList[index-1] ? acupunctureList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ acupunctureList[index-1] ? acupunctureList[index-1].TIME_STRING : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 오른쪽: 신입/재입/퇴원 -->
          <div style="width: fit-content; margin:0 !important;">
            <table id="dashboardTable3" border="1" style="width: fit-content;">
              <thead>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" rowspan="2">신입({{ inInitPatientList.length }})</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="2">재입({{ inPatientList.length }})</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" rowspan="2">퇴원({{ outPatientList.length }})</th>
                </tr>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" >정달림({{ jeongDallimList.length }})</th>
                  <th style="text-align: center;font-size: large;font-weight: bold;" >박은영({{ parkEunYoungList.length }})</th>
                </tr>
              </thead> 
              <tbody>
                <tr :key="index" v-for="index in patientRowCount">
                  <td>{{ inInitPatientList[index-1] ? inInitPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ jeongDallimList[index-1] ? jeongDallimList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ parkEunYoungList[index-1] ? parkEunYoungList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ outPatientList[index-1] ? outPatientList[index-1].PATIENT_USERNAME : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="width: 20%; margin:0 !important;">
            <table id="dashboardTable2" style="flex: auto" border="1">
                <thead>
                  <tr>
                    <th style="text-align: center;font-size: large;font-weight: bold;" colspan="6">진료 예약</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">김지호 원장님({{ kimList.length }})</th>
                    <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">구자일 원장님({{ kooList.length }})</th>
                    <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">한연수 원장님({{ hanList.length }})</th>
                  </tr>
                  <tr :key="index" v-for="index in reservationMaxCount">
                    <td>{{ kimList[index-1] ? kimList[index-1].PATIENT_USERNAME : ''}}</td>
                    <td>{{ kimList[index-1] ? returnDoctorTdDetail(kimList[index-1], '02004') : ''}}</td>
                    <td>{{ kooList[index-1] ? kooList[index-1].PATIENT_USERNAME : ''}}</td>
                    <td>{{ kooList[index-1] ? returnDoctorTdDetail(kooList[index-1], '02006') : '' }}</td>
                    <td>{{ hanList[index-1] ? hanList[index-1].PATIENT_USERNAME : ''}}</td>
                    <td>{{ hanList[index-1] ? returnDoctorTdDetail(hanList[index-1], '02016') : ''}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>

          <!-- 진료 예약 (기존처럼 아래쪽에 배치) -->
          <!-- <div class="vx-row w-full mb-base" style="width: 98%; padding: 13mm;">
            <table id="dashboardTable2" style="flex: auto" border="1">
              <thead>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="6">진료 예약</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">김지호 원장님({{ kimList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">구자일 원장님({{ kooList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">한연수 원장님({{ hanList.length }})</th>
                </tr>
                <tr :key="index" v-for="index in reservationMaxCount">
                  <td>{{ kimList[index-1] ? kimList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ kimList[index-1] ? returnDoctorTdDetail(kimList[index-1], '02004') : ''}}</td>
                  <td>{{ kooList[index-1] ? kooList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ kooList[index-1] ? returnDoctorTdDetail(kooList[index-1], '02006') : '' }}</td>
                  <td>{{ hanList[index-1] ? hanList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{ hanList[index-1] ? returnDoctorTdDetail(hanList[index-1], '02016') : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div> -->

          <!-- <div class="vx-row w-full lg:w-5/5 mb-base">
            <table id="dashboardTable2" border="1">
              <thead>
                <tr>
                  <th style="text-align: center;font-size: large;font-weight: bold;" colspan="6">진료 예약</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">김지호 원장님({{ kimList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">구자일 원장님({{ kooList.length }})</th>
                  <th style="text-align: center;font-size: larger;font-weight: bold;" colspan="2">한연수 원장님({{ hanList.length }})</th>
                </tr>
                <tr :key="index" v-for="index in reservationMaxCount">
                  <td>{{kimList[index-1] ? kimList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{kimList[index-1] ? returnDoctorTdDetail(kimList[index-1], '02004') : ''}}</td>
                  <td>{{kooList[index-1] ? kooList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{kooList[index-1] ? returnDoctorTdDetail(kooList[index-1], '02006') : '' }}</td>
                  <td>{{hanList[index-1] ? hanList[index-1].PATIENT_USERNAME : ''}}</td>
                  <td>{{hanList[index-1] ? returnDoctorTdDetail(hanList[index-1], '02016') : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div> -->

      
        
      </div>
    </div>
      
        
      
    </vx-card>
  </div>
</template>

<script>
import axiosClass from "@/../util/axiosClass";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { validationMobile } from "@/../util/validation";
import store from "@/store/store";
import xlsx from "xlsx";
import { EventBus } from '../../../util/vue-event-bus';
import dateClass from "@/../util/dateClass";
import moment from "moment";
import Vue from "vue";
import VueHtml2Canvas from "vue-html2canvas";
import myPrint from "../printComponent/myPrint.vue";
Vue.use(VueHtml2Canvas);
export default {
  name: 'ScheduleTable',
  components: {
    DatePicker,
    myPrint,
  },
  data() {
    return {
      userUid : '',
      userLevel: '',
      nowDate: '',
      gubun_list: [
        { VALUE: '1', TEXT: '초진' },
        { VALUE: '2', TEXT: '재진' },
        { VALUE: '3', TEXT: '신입진료' },
        { VALUE: '4', TEXT: '재입진료' },
        { VALUE: '5', TEXT: '입원중진료' },
        { VALUE: '6', TEXT: '퇴원진료' },
        { VALUE: '97', TEXT: '휴진' },
        { VALUE: '98', TEXT: '외래' },
        { VALUE: '99', TEXT: '기타' },
      ],
      rawData: [],
      medicalDetailCodeList: [],
      orderList: [],
      reservationList: [],
      reservationMaxCount : 0,
      inInitPatientList: [],
      inPatientList: [],
      outPatientList: [],
      patientRowCount:0,
      kimList:[], // 김지호원장님
      kooList:[], // 구자일원장님
      hanList:[], // 한연수원장님
      keumList:[], // 금충수원장님
      jeongList:[], // 김정권원장님
      unSelectedList: [], // 양방원장님 미지정 리스트
      mergedJeongList: [],
      mergedKeumList: [],
      mergedUnSelectedList: [],
      orderMaxCount: 0,
      acupunctureList : [],
      medicalCodeList: ['03001', '01001', '01002'],
      acupunctureCodeList: ['03006'],
      jeongDallimList : [],
      parkEunYoungList : [],

    };
  },
  methods: {
    async init(date) {
      
      try {
        this.userUid = store.getters.getUID;
        this.userLevel = store.getters.getCDLEVEL;

        let params = {
          userUid: this.userUid,
          nowDate: this.nowDate,
        };

        this.$vs.loading({
          type: "default",
          container: "#dashboardTable",
          background: "rgba(0,0,0,0.1)",
          color: "primary",
          scale: 1.5,
        });

        const { data } = await axiosClass.get(
          "/api/patient/dashboardSchedule",
          params,
          true
        );
        
        // 진료예약 테이블 데이터 조성
        this.rawData = data.dashboardScheduleData.data;
        
        this.reservationList = this.rawData.filter((data) => data.MEDICAL_CODE.startsWith("02"));
        
        this.kimList = this.reservationList.filter((data) => data.MEDICAL_CODE === "02004");
        this.kooList = this.reservationList.filter((data) => data.MEDICAL_CODE === "02006");
        this.hanList = this.reservationList.filter((data) => data.MEDICAL_CODE === "02016");
        
        this.reservationMaxCount = Math.max(this.kimList.length, this.kooList.length, this.hanList.length);
        // 진료예약 끝

        // 입원 재원 퇴원 환자
        this.inInitPatientList = data.inInitPatient.data;
        this.inPatientList = data.inPatient.data;
        this.outPatientList = data.outPatient.data;

        this.jeongDallimList = this.inPatientList.filter((data) => ['02022'].includes(data.CONSULT_DOCTOR_UID));
        this.parkEunYoungList = this.inPatientList.filter((data) => ['02024'].includes(data.CONSULT_DOCTOR_UID));

        this.patientRowCount = Math.max(this.inInitPatientList.length, this.jeongDallimList.length, this.parkEunYoungList.length, this.outPatientList.length);
        // 입원 재원 퇴원 환자 끝

        // 치료 디테일
        this.medicalDetailCodeList = data.medicalDetailCode.data;
        // 치료 디테일 끝
        
        // 오더요청
        //this.orderList = this.rawData.filter((data) => data.MEDICAL_CODE.slice(0, 2) === '03');
        
        this.orderList = this.rawData.filter((data) => ![6, 11, 12].includes(data.CD_STATUS));
        
        this.jeongList = this.orderList.filter((data) => (data.WEST_MEDICAL_UID === "02011" && this.medicalCodeList.includes(data.MEDICAL_CODE)));
        this.keumList = this.orderList.filter((data) => (data.WEST_MEDICAL_UID === "02020" && this.medicalCodeList.includes(data.MEDICAL_CODE)));
        this.unSelectedList = this.orderList.filter((data) => (data.WEST_MEDICAL_UID === "09001" && this.medicalCodeList.includes(data.MEDICAL_CODE)));
        this.acupunctureList = this.rawData.filter((data) => this.acupunctureCodeList.includes(data.MEDICAL_CODE));
        // 오더요청 끝

        setTimeout(() => {
          this.$vs.loading.close("#dashboardTable > .con-vs-loading");
        }, 100);
      } catch (e) {
        setTimeout(() => {
          this.$vs.loading.close("#dashboardTable > .con-vs-loading");
        }, 100);
        console.log(e.response ? e.response.data : e);
      }
    },
    // 특정 리스트에서 중복된 PATIENT_UID를 병합하는 함수
    mergeListByPatientUID(list) {
      const groupedList = this.groupByPatientUID(list);

      return Object.keys(groupedList).map(uid => {
        const patientDataList = groupedList[uid];

        // 첫 번째 항목을 기준으로 기본 정보를 가져옴
        const mergedData = { ...patientDataList[0] };
        
        // 해당 환자의 모든 MEDICAL_DETAIL_NM을 합쳐서 중복을 제거
        const allDetails = patientDataList.flatMap(data => {
          const medicalDetailsArray = data.MEDICAL_DETAILS.split(',');
          return medicalDetailsArray.map(detailCode => {
            const matched = this.medicalDetailCodeList.find(item => 
              item.MEDICAL_CD == data.MEDICAL_CODE && item.MEDICAL_DETAIL_CD == detailCode.trim()
            );
            return matched ? matched.MEDICAL_DETAIL_NM : '';
          });
        }).filter(Boolean); // 유효한 값만 필터링

        // 중복된 MEDICAL_DETAIL_NM 제거
        mergedData.MEDICAL_DETAIL_NM = [...new Set(allDetails)].join(', ');

        return mergedData;
      });
    },
    groupByPatientUID(list) {
      return list.reduce((acc, current) => {
        if (!acc[current.PATIENT_UID]) {
          acc[current.PATIENT_UID] = [];
        }
        acc[current.PATIENT_UID].push(current);
        return acc;
      }, {});
    },

    returnOrderTdDetail (listData, patientUID) {
      if(patientUID != '') {
        // jeongList를 PATIENT_UID로 그룹화
        const groupedByPatientUID = this.groupByPatientUID(listData);

        // 그룹화된 데이터에서 해당 PATIENT_UID에 속하는 항목들만 가져옴
        const patientDataList = groupedByPatientUID[patientUID];

        if (!patientDataList) return ''; // 해당 PATIENT_UID에 데이터가 없을 경우

        // 해당 PATIENT_UID에 속한 항목들의 MEDICAL_DETAIL_NM을 모두 결합
        const matchedDetails = patientDataList.map(data => {
          const medicalDetailsArray = data.MEDICAL_DETAILS.split(',');
          
          // 각각의 MEDICAL_DETAIL_CD에 대해 matching
          return medicalDetailsArray.map(detailCode => {
            const matched = this.medicalDetailCodeList.find(item => 
              item.MEDICAL_CD == data.MEDICAL_CODE && item.MEDICAL_DETAIL_CD == detailCode.trim()
            );
            return matched ? matched.MEDICAL_DETAIL_NM : '';
          }).filter(Boolean).join(', '); // 필터로 유효한 값만 반환
        });

        // 중복된 MEDICAL_DETAIL_NM 제거 후 결합
        const uniqueDetails = [...new Set(matchedDetails)];

        return uniqueDetails.join(', ');
      } else {
        return ''
      }
    },
    returnDoctorTdDetail (data, doctorId) {
      if(data.MEDICAL_CODE == doctorId){
        const gubun = this.gubun_list.find(item => item.VALUE === data.MEDICAL_DETAILS);
        return data.TIME_STRING + ' ' + (gubun ? gubun.TEXT : '');
      } else {
        return ''
      }
    },
    printDashboard () {
      var initBody = document.body.innerHTML; // body영역의 HTML 저장
      var printContent = document.getElementById('printArea').innerHTML;

      document.body.innerHTML = printContent; // 스타일과 인쇄할 내용을 body에 적용

      function restoreBody() {
        document.body.innerHTML = initBody; // body 영역의 HTML 복원
        window.location.reload(); // 페이지 새로고침
      }

      window.onafterprint = restoreBody; // 프린트 후 이벤트 핸들러 설정
      
      window.print();
      window.onafterprint = null;
    },
  },
  async mounted() {
    this.nowDate = moment().format("YYYY-MM-DD");
    await this.init(this.nowDate);
    this.mergedJeongList = this.mergeListByPatientUID(this.jeongList);
    this.mergedKeumList = this.mergeListByPatientUID(this.keumList);
    this.mergedUnSelectedList = this.mergeListByPatientUID(this.unSelectedList);
    this.mergedKeumList = [...this.mergedKeumList, ...this.mergedUnSelectedList];
    this.orderMaxCount = Math.max(this.mergedJeongList.length, this.mergedKeumList.length, this.acupunctureList.length);
  },
  beforeDestroy() {
  },
};
</script>

<style>
#dashboardTable, #dashboardTable2, #dashboardTable3 {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
}

#dashboardTable td, #dashboardTable2 td, #dashboardTable3 td {
  font-size: 15px;
  white-space: nowrap;
  padding: 4px;
  width: fit-content;
  border: 1px solid #000;
}

#dashboardTable th, #dashboardTable2 th, #dashboardTable3 th {
  font-size: 15px;
  white-space: nowrap;
  padding: 4px;
  width: fit-content;
  border: 1px solid #000;
}
</style>

<style scoped>
@media print {
  @page {
    size: A4 landscape;
    margin: 20mm 5mm;
  }
  #printArea {
    zoom: 80% !important;
  }
}

.dashboard-container {
  margin: 0;
  padding: 20mm 5mm;
  font-family: Arial, sans-serif;
  width: 100%;
}

.vx-card {
  margin: 0;
  padding: 20mm 5mm;
}

#printArea {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin: 0 auto;
}

.table-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  width: 100%;
  margin: 0 auto;
}

.full-screen {
    width: 100%;
    height: 100vh; /* 뷰포트 전체 높이 */
    overflow: auto; /* 넘치는 내용도 표시 */
  }

  th, td {
    padding: 5px;
    text-align: left;
    border : 1px solid black;
  }
</style>
